import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContaEditarComponent } from './conta-editar.component'; 


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ContaEditarComponent }
    ])],
    exports: [RouterModule]
})
export class ContaEditarRoutingModule { }
